import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FileUpload } from '../../components';

var UploadHandlerInstance = function UploadHandlerInstance(_ref) {
  var type = _ref.type,
      file = _ref.file,
      isUploading = _ref.isUploading,
      message = _ref.message,
      onFileUpload = _ref.onFileUpload,
      onFileDelete = _ref.onFileDelete;
  return React.createElement(Fragment, null, React.createElement(FileUpload, {
    file: file,
    isUploading: isUploading,
    onChange: function onChange(newFile) {
      return onFileUpload(type, newFile);
    },
    onDelete: function onDelete() {
      return onFileDelete(type, file._id);
    }
  }), !file && message && React.createElement('div', {
    className: 'mtop-30'
  }, message));
};

var UploadHandler = function UploadHandler(_ref2) {
  var type = _ref2.type,
      files = _ref2.files,
      fileState = _ref2.fileState,
      message = _ref2.message,
      onFileUpload = _ref2.onFileUpload,
      onFileDelete = _ref2.onFileDelete;
  var isUploading = fileState && fileState.uploading || false;
  return React.createElement(Fragment, null, files[type] && files[type].map(function (file, index) {
    return React.createElement(UploadHandlerInstance, {
      key: index,
      type: type,
      file: file,
      message: message,
      onFileUpload: onFileUpload,
      onFileDelete: onFileDelete
    });
  }), React.createElement(UploadHandlerInstance, {
    type: type,
    message: message,
    isUploading: isUploading,
    onFileUpload: onFileUpload,
    onFileDelete: onFileDelete
  }));
};

UploadHandler.propTypes = {
  type: PropTypes.string.isRequired,
  files: PropTypes.object.isRequired,
  fileState: PropTypes.object.isRequired,
  message: PropTypes.object,
  onFileUpload: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired
};
export default UploadHandler;